import { render, staticRenderFns } from "./Notenuebersicht.vue?vue&type=template&id=47ebd57e"
import script from "./Notenuebersicht.vue?vue&type=script&lang=js"
export * from "./Notenuebersicht.vue?vue&type=script&lang=js"
import style0 from "./Notenuebersicht.vue?vue&type=style&index=0&id=47ebd57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports